"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var hooks_1 = require("@culturehq/hooks");
var classnames_1 = __importDefault(require("../classnames"));
var useId_1 = __importDefault(require("../utils/useId"));
var Button_1 = __importDefault(require("./buttons/Button"));
var DropdownContext = react_1.default.createContext({
    buttonId: "chq-0",
    buttonRef: react_1.default.createRef(),
    onChange: function () { },
    onToggle: function () { },
    open: false,
    selected: null
});
var DropdownCheck = function () { return (react_1.default.createElement("svg", { "aria-hidden": true, "data-chq-dropdown-check": true, viewBox: "0 0 16 16" },
    react_1.default.createElement("circle", { r: "7", cx: "8", cy: "8" }),
    react_1.default.createElement("path", { d: "M 5 9 l 2 2 l 4 -5" }))); };
var DropdownButton = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = react_1.useContext(DropdownContext), buttonId = _b.buttonId, buttonRef = _b.buttonRef, open = _b.open, onToggle = _b.onToggle;
    return (react_1.default.createElement(Button_1.default, __assign({}, props, { "aria-haspopup": "listbox", id: buttonId, inverted: true, onClick: onToggle, ref: buttonRef }),
        children,
        react_1.default.createElement("span", { "aria-hidden": true, className: classnames_1.default("chq-dd--caret", { "chq-dd--caret-ex": !!open }) })));
};
var DropdownListBox = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = react_1.useContext(DropdownContext), buttonId = _b.buttonId, open = _b.open;
    return (react_1.default.createElement("ul", __assign({}, props, { "aria-expanded": !!open, "aria-labelledby": buttonId, role: "listbox" }), children));
};
var DropdownOption = function (_a) {
    var children = _a.children, value = _a.value, props = __rest(_a, ["children", "value"]);
    var _b = react_1.useContext(DropdownContext), open = _b.open, onChange = _b.onChange, onToggle = _b.onToggle, selected = _b.selected;
    var onClick = function () {
        onChange(value);
        onToggle();
    };
    var onKeyDown = function (event) {
        if (event.key === "Enter") {
            onClick();
        }
    };
    return (react_1.default.createElement("li", __assign({}, props, { "aria-selected": value === selected, onClick: onClick, onKeyDown: onKeyDown, role: "option", tabIndex: open ? 0 : -1 }),
        value === selected && react_1.default.createElement(DropdownCheck, null),
        children));
};
// Disabling the following rule because the top-level div is just capturing all
// keyboard events from the button or from the list elements, and it's better to
// just keep it here are the top level. See:
// https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md#case-the-event-handler-is-only-being-used-to-capture-bubbled-events
/* eslint-disable jsx-a11y/no-static-element-interactions */
var Dropdown = function (_a) {
    var children = _a.children, className = _a.className, onChange = _a.onChange, selected = _a.selected, props = __rest(_a, ["children", "className", "onChange", "selected"]);
    var _b = react_1.useState(null), open = _b[0], setOpen = _b[1];
    var onClose = react_1.useCallback(function () { return setOpen(false); }, [setOpen]);
    var buttonRef = react_1.useRef(null);
    var buttonId = useId_1.default();
    var containerRef = hooks_1.useClickOutside(onClose);
    var onKeyDown = function (event) {
        if (event.key === "Escape") {
            onClose();
        }
    };
    var context = react_1.useMemo(function () { return ({
        buttonId: buttonId,
        buttonRef: buttonRef,
        onChange: onChange,
        onToggle: function () { return setOpen(function (value) { return !value; }); },
        open: open,
        selected: selected
    }); }, [buttonId, buttonRef, onChange, open, setOpen, selected]);
    return (react_1.default.createElement(DropdownContext.Provider, { value: context },
        react_1.default.createElement("div", __assign({}, props, { className: classnames_1.default("chq-dd", className), onKeyDown: onKeyDown, ref: containerRef }), children)));
};
Dropdown.Button = DropdownButton;
Dropdown.ListBox = DropdownListBox;
Dropdown.Option = DropdownOption;
exports.default = Dropdown;
